import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/images/menu/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-194113b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "header-bar" }
const _hoisted_2 = { class: "btn-content notice-btn-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-notice" }, null, -1))
const _hoisted_4 = { class: "el-badge__content el-badge__content--danger is-fixed is-dot" }
const _hoisted_5 = { class: "btn-content" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "btn-img",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn-content" }, "Connect Wallet", -1))
const _hoisted_8 = { class: "btn-content" }

import {
  computed, onMounted, ref, watch,
} from 'vue';
import { useStore } from '@/store';
import WalletDialog from '@/components/WalletDialog.vue';
import NoticeDialog from '@/components/Index/NoticeDialog.vue';
import { WalletConnectMethod } from '@/store/state';
import { ActionCommands } from '@/store/actions';
import { getBalance } from '@/common/contracts/apis/erc20-api';
import { getNecoTokenAddress } from '@/common/contracts/apis/neco-token-api';
import Tools from '@/common/tools';
import { addNecoTokenToMetamask } from '@/common/metamask-apis';
import { NOTICE_READ_KEY, NOTICE_READ_PREV_KEY } from '@/configs/index/notice';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();

const noticeDialogVisible = ref(false);
const noticeHaveRead = ref(true);

const currentAccount = computed(() => {
  if (store.state.currentAccount) {
    const prefix = store.state.currentAccount?.substr(0, 5);
    const tail = store.state.currentAccount?.substr(
      store.state.currentAccount.length - 5,
      store.state.currentAccount.length,
    );
    return `${prefix}...${tail}`;
  }
  return store.state.currentAccount;
});

async function logoutMetamask() {
  if (store.state.web3 !== null
    && store.state.walletConnectMethod === WalletConnectMethod.Walletconnect) {
    (store.state.web3.currentProvider as any).disconnect();
  } else {
    await store.dispatch(ActionCommands.SET_CURRENT_ACCOUNT, undefined);
  }
}

const walletDialogVisible = ref(false);
const showWalletConnectDialog = () => {
  if (store.state.currentAccount === undefined) {
    walletDialogVisible.value = true;
  }
};

const necoBalance = ref('0');
const getNECOTokenBalance = () => {
  const necoAddress = getNecoTokenAddress(store.state.currentChainId);
  console.log(necoAddress);
  if (store.state.web3 !== null
    && store.state.currentAccount !== undefined
    && necoAddress !== undefined) {
    getBalance(store.state.web3, necoAddress, store.state.currentAccount).then((result) => {
      necoBalance.value = Tools.truncateDecimals(result);
    });
  }
};

const addNECOToMeatmask = () => {
  addNecoTokenToMetamask(store.state.currentChainId);
};

onMounted(() => {
  getNECOTokenBalance();

  if (NOTICE_READ_PREV_KEY) {
    localStorage.removeItem(NOTICE_READ_PREV_KEY);
  }
  noticeHaveRead.value = !!localStorage.getItem(NOTICE_READ_KEY);
});

watch([
  () => store.state.web3,
  () => store.state.currentAccount,
  () => store.state.currentChainId], () => {
  getNECOTokenBalance();
});

function showNotice() {
  noticeDialogVisible.value = true;
  noticeHaveRead.value = true;
  localStorage.setItem(NOTICE_READ_KEY, 'read');
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_button, {
      class: "white-btn",
      onClick: showNotice
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createTextVNode(" " + _toDisplayString(_ctx.$t('announ')) + " ", 1),
          _withDirectives(_createElementVNode("sup", _hoisted_4, null, 512), [
            [_vShow, !noticeHaveRead.value]
          ])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_el_tooltip, {
      content: _ctx.$t('addNECOToMetamask'),
      placement: "bottom",
      effect: "light"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: addNECOToMeatmask,
          class: "white-btn"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createTextVNode(" " + _toDisplayString(necoBalance.value), 1)
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["content"]),
    _createElementVNode("div", {
      class: "add-to-metamask-btn",
      onClick: showWalletConnectDialog
    }, [
      (_unref(store).state.currentAccount === undefined)
        ? (_openBlock(), _createBlock(_component_el_button, {
            key: 0,
            class: "white-btn"
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_el_dropdown, {
            key: 1,
            trigger: "click",
            placement: "bottom-end"
          }, {
            dropdown: _withCtx(() => [
              _createVNode(_component_el_dropdown_menu, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_dropdown_item, { onClick: logoutMetamask }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('logout')), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_button, { class: "white-btn" }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(currentAccount)), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
    ]),
    _createVNode(WalletDialog, {
      visible: walletDialogVisible.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((walletDialogVisible).value = $event))
    }, null, 8, ["visible"]),
    _createVNode(NoticeDialog, {
      visible: noticeDialogVisible.value,
      "onUpdate:visible": _cache[1] || (_cache[1] = ($event: any) => ((noticeDialogVisible).value = $event))
    }, null, 8, ["visible"])
  ]))
}
}

})